(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["athar-shop-look"] && !Shopify.designMode) return;
  try {
    
(function () {
  function highlight(root, id) {
    root.querySelectorAll('[data-athar-card]').forEach(function (c) { c.classList.toggle('is-active', c.dataset.atharCard === id); });
    root.querySelectorAll('[data-athar-dot]').forEach(function (d) { d.classList.toggle('is-active', d.dataset.atharDot === id); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var dot = e.target.closest('[data-athar-dot]');
    if (dot) {
      var root = dot.closest('[data-athar-look]');
      var id = dot.dataset.atharDot;
      var card = root.querySelector('[data-athar-card="' + id + '"]');
      if (card) card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      highlight(root, id);
      return;
    }

    var arrow = e.target.closest('[data-athar-prev], [data-athar-next]');
    if (!arrow) return;
    var section = arrow.closest('[data-athar-look]');
    var t = section && section.querySelector('[data-athar-track]');
    if (!t) return;
    var first = t.querySelector('.athar-look__card');
    var step = first ? first.getBoundingClientRect().width + 16 : t.clientWidth * 0.88;
    var dir = arrow.hasAttribute('data-athar-next') ? 1 : -1;
    if (getComputedStyle(t).direction === 'rtl') dir = -dir;
    t.scrollBy({ left: dir * step, behavior: 'smooth' });
  });

  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el && el.closest && el.closest('[data-athar-look]')) {
      el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["athar-try-on-wall"] && !Shopify.designMode) return;
  try {
    
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  function trim(img) {
    var w = img.naturalWidth, h = img.naturalHeight, c = document.createElement('canvas');
    c.width = w; c.height = h;
    var x = c.getContext('2d'); x.drawImage(img, 0, 0);
    var d = x.getImageData(0, 0, w, h).data, rows = new Uint32Array(h), cols = new Uint32Array(w), i, X, Y;
    for (Y = 0; Y < h; Y++) for (X = 0; X < w; X++) {
      i = (Y * w + X) * 4;
      if (d[i + 3] > 20 && (d[i] < 236 || d[i + 1] < 236 || d[i + 2] < 236)) { rows[Y]++; cols[X]++; }
    }
    var t = 0, b = h - 1, l = 0, r = w - 1;
    while (t < h - 1 && rows[t] < w * 0.15) t++;
    while (b > t && rows[b] < w * 0.15) b--;
    while (l < w - 1 && cols[l] < h * 0.15) l++;
    while (r > l && cols[r] < h * 0.15) r--;
    if (r - l < w * 0.2 || b - t < h * 0.2) return null;
    var o = document.createElement('canvas'); o.width = r - l + 1; o.height = b - t + 1;
    o.getContext('2d').drawImage(c, l, t, o.width, o.height, 0, 0, o.width, o.height);
    return { url: o.toDataURL('image/jpeg', 0.9), ratio: o.width / o.height };
  }
  function setR(el, x, y, w, h) { el.setAttribute('x', x); el.setAttribute('y', y); el.setAttribute('width', w); el.setAttribute('height', h); }
  function realFrame(s) {
    var g = s.querySelector('.athar-tow__piece');
    if (!g || !g.dataset.src) return;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      var t; try { t = trim(img); } catch (e) { return; }
      if (!t) return;
      var land = t.ratio > 1.05, W = land ? 90 : 60, H = land ? 60 : 90;
      var x = +g.dataset.cx - W / 2, y = +g.dataset.bottom - H;
      setR(g.querySelector('.athar-tow__frame'), x, y, W, H);
      var art = g.querySelector('.athar-tow__art'), im = document.createElementNS(NS, 'image');
      setR(im, x, y, W, H);
      im.setAttribute('href', t.url);
      im.setAttribute('preserveAspectRatio', 'none');
      im.setAttribute('class', 'athar-tow__art');
      art.parentNode.replaceChild(im, art);
      var edge = g.querySelector('.athar-tow__edge'); if (edge) edge.remove();
      setR(g.querySelector('.athar-tow__size-bg'), +g.dataset.cx - 26, y + H + 8, 52, 15);
      var tx = g.querySelector('.athar-tow__size-t');
      tx.setAttribute('y', y + H + 18.6);
      tx.textContent = land ? g.dataset.ll : g.dataset.lp;
    };
    img.src = g.dataset.src;
  }
  function init() {
    document.querySelectorAll('[data-athar-tow]').forEach(function (s) {
      if (s.dataset.towReady) return;
      s.dataset.towReady = '1';
      realFrame(s);
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      s.classList.add('is-armed');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { s.classList.add('is-play'); io.disconnect(); }
        });
      }, { threshold: 0.35 });
      io.observe(s.querySelector('.athar-tow__visual') || s);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atharn-doubts"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var lists = document.querySelectorAll('[data-athar-dbt-list]');
    if (!lists.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    lists.forEach(function (list) {
      if (list.dataset.atharDbtReady === 'true') return;
      list.dataset.atharDbtReady = 'true';

      var items = list.querySelectorAll('.athar-dbt__item');
      if (!items.length) return;

      if (reduce || !('IntersectionObserver' in window)) return;

      list.classList.add('is-armed');

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -6% 0px' });

      items.forEach(function (item) { observer.observe(item); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
